import { z } from 'zod';
import { timestampSchema } from './shared';

export const contentSectionRowSchema = z.object({
  id: z.string().min(1),
  label: z.string().min(1),
  heading: z.string(),
  body: z.string(),
  isVisible: z.boolean(),
  metadata: z.record(z.string(), z.string()).nullable(),
  updatedAt: timestampSchema,
});

// id is admin-provided (section identifier, not generated UUID)
export const contentSectionInsertSchema = z.object({
  id: z.string().min(1),
  label: z.string().min(1),
  heading: z.string().optional(),
  body: z.string().optional(),
  isVisible: z.boolean().optional(),
  metadata: z.record(z.string(), z.string()).nullable().optional(),
});

export const contentSectionUpdateSchema = contentSectionInsertSchema.partial();

export type ContentSectionRow = z.infer<typeof contentSectionRowSchema>;
export type ContentSectionInsert = z.input<typeof contentSectionInsertSchema>;
export type ContentSectionUpdate = z.input<typeof contentSectionUpdateSchema>;
